import { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { MEMBERSHIP_PRICE_MNT } from '@big2/shared';
import { Icon } from '../Icon.js';
import './tableInteractions.css';

export interface VipFeatureModalProps {
  title: string;
  description: string;
  isMn: boolean;
  onClose: () => void;
  /** Opens membership checkout (or sign-in for guests). */
  onUnlock: () => void;
}

/** Explains that a feature is VIP-only, using the same styling as the table-interaction VIP prompt. */
export function VipFeatureModal({ title, description, isMn, onClose, onUnlock }: VipFeatureModalProps) {
  const titleId = useId();
  const unlockRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const previouslyFocused = document.activeElement as HTMLElement | null;
    unlockRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      previouslyFocused?.focus();
    };
  }, [onClose]);

  const price = isMn
    ? `VIP авах · ${MEMBERSHIP_PRICE_MNT.toLocaleString('mn-MN')}₮`
    : `Unlock VIP · ${MEMBERSHIP_PRICE_MNT.toLocaleString('en-US')} MNT`;

  return createPortal(
    <div className="table-interaction-backdrop" onClick={onClose}>
      <div className="table-interaction-card" role="dialog" aria-modal="true" aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}>
        <div className="table-interaction-header">
          <strong id={titleId} className="target-name">👑 {title}</strong>
          <button type="button" className="close-button" onClick={onClose} aria-label={isMn ? 'Хаах' : 'Close'}>
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="vip-upsell-box vip-feature-modal-body">
          <div className="vip-upsell-content">
            <p>{description}</p>
            <button ref={unlockRef} type="button" className="vip-unlock-btn" onClick={() => { onClose(); onUnlock(); }}>
              👑 {price}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
